export default {
  MEASURE_PRODUCT_IMPRESSION: 'productImpression',
  MEASURE_PROMOTION_IMPRESSION: 'promotionImpression',
  CLICK_PRODUCT_IMPRESSION: 'productClick',
  CLICK_PROMOTION_IMPRESSION: 'promotionClick',
  MEASURE_VIEW: 'productDetailImpression',
  ADD_ORDER_TO_CART: 'addOrderToCart',
  REMOVE_FROM_CART: 'remove_from_cart',
  CHECKOUT: 'checkout',
  TRANSACTION: 'transaction',
  MEASURE_KEYWORD_IMPRESSION: 'keywordImpression',
  CLICK_KEYWORD_IMPRESSION: 'keywordClick',
  MEASURE_BRAND_IMPRESSION: 'brandImpression',
  CLICK_BRAND_IMPRESSION: 'brandClick',
  MEASURE_CONTENT_IMPRESSION: 'contentImpression',
  CLICK_CONTENT_IMPRESSION: 'contentClick',
  VARIABLE_EVENT_IMPRESSION: 'variableEventImpression',
  VARIABLE_EVENT_CLICK: 'variableEventClick',
  CHECKBOX_CLICK: 'checkboxClick',
  ANIMAL_PASSPORT_CREATING: 'animalPassportCreating',
  SHOPPING_CART: 'shoppingCart',
  SET_INSIDER_BASKET: 'setInsiderBasket',
  UPDATE_ACTIVE_VARIANT: 'updateActiveVariant',
  SET_INSIDER_LIST: 'setInsiderList',
  ADD_TO_CART: 'add_to_cart',
  ADD_PAYMENT_INFO: 'add_payment_info',
  LOGIN: 'login',
  PURCHASE: 'purchase',
  VIEW_CART: 'view_cart',
  SIGN_UP: 'sign_up',
  SEARCH: 'search',
  BEGIN_CHECKOUT: 'begin_checkout',
  VIEW_PROMOTION: 'view_promotion',
  SELECT_PROMOTION: 'select_promotion',
  VIEW_PRODUCTS: 'view_item_list',
  PRODUCT_CLICK: 'select_item',
  VIEW_ITEM: 'view_item',
  FILTER_USE: 'filter_use',
  FILTER_CLEAR: 'filter_clear',
  SORTING_USE: 'sorting_use',
  SHORTCUT_BUTTON_USE: 'shortcut_button_use',
  UPDATE_INSIDER_ACTIVE_VARIANT: 'updateInsiderActiveVariant',
  LOGIN_FAILED: 'login_failed',
  RESET_PASSWORD: 'reset_password'
};
